import type { Draft } from "immer"
import { produce } from "immer"
import type { BonusEmailHackActions } from "./actions-email-hack"
import { BonusEmailHackActionType } from "./actions-email-hack"
import { initialState } from "./selectors"
import type { BonusState } from "./types"

export default function reducer(
  state: BonusState = initialState,
  action: BonusEmailHackActions
) {
  return produce(state, (nextState: Draft<BonusState>) => {
    switch (action.type) {
      case BonusEmailHackActionType.BONUS_EMAIL_HACK_HIDE_UPSELL:
        nextState.hideUpsell = action.hideUpsell

        return

      case BonusEmailHackActionType.BONUS_ADD_EMAIL_HACK_DATA:
        nextState.emailHack = action.emailHack

        return
    }
  })
}
